// extracted by mini-css-extract-plugin
module.exports = {"message":"message--zgUDd","title":"title--We0z1"};